// extracted by mini-css-extract-plugin
module.exports = {"feed":"RssFeed_feed__2-qGp","content":"RssFeed_content__Ew7Z-","header":"RssFeed_header__2qGEF","items":"RssFeed_items__1YJH-"};